module.exports = __webpack_public_path__ + "static/media/0a3473eb-27c1-49bb-9461-67ac14b2a2bb.366e6c86.jpg";